<template>
  <div
    v-if="opportunityBeingVisited.mentoring.isActive"
    id="mentorings-info"
    class="container"
  >
    <div class="columns">
      <div id="mentorings-box" class="column box">
        <mentorings-title
          title="Mentorias (Online)"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'mentoring')"
          @close-card="$emit('close-card', 'mentoring')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <themes
            :themes="opportunityBeingVisited.mentoring.themes"
            :specificThemes="opportunityBeingVisited.mentoring.specificThemes"
          />

          <prerequisites
            :minPublic="opportunityBeingVisited.mentoring.minPublic || 2"
            :advance="opportunityBeingVisited.mentoring.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.mentoring.courses"
            :states="opportunityBeingVisited.mentoring.states"
          />

          <counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
            action="a mentoria"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <mentoring-request-modal
        :minPublic="opportunityBeingVisited.mentoring.minPublic || 2"
        :advance="opportunityBeingVisited.mentoring.advance"
      />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import mentoringsTitle from "./card/Title";
import themes from "./card/Themes";
import prerequisites from "./card/Prerequisites";
import counterparts from "./card/Counterparts";
import mentoringRequestModal from "../request-modal/MentoringRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    mentoringsTitle,
    themes,
    prerequisites,
    counterparts,
    mentoringRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  mounted() {
    this.description = descriptions.mentoring;
  }
};
</script>

<style scoped>
#mentorings-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #mentorings-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#mentorings-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
